import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ChildEvent, ScrBaseComponent } from "../../../../base.component";
@Component({
  selector: 'app-add-payment',
  templateUrl: './add-payment.component.html'
})
export class AddPaymentComponent extends ScrBaseComponent {

  paymentType = 'creditCard';

  @Input() hasDefault!: boolean;
  @Output() emitAction = new EventEmitter<ChildEvent>();

  raiseChildEvent(event: ChildEvent) {
    this.emitAction.emit(event);
  }

}
